/**
 * OutboundPage Component
 * 
 * Outbound calling features for locations with outbound capabilities enabled.
 * Only accessible when selected location has "outbound": true
 */

import React, { useState } from 'react';
import CreateCampaignTab from '../components/outbound/CreateCampaignTab';
import DraftsTab from '../components/outbound/DraftsTab';
import HistoryTab from '../components/outbound/HistoryTab';

const OutboundPage = () => {
  const [activeTab, setActiveTab] = useState('create');

  const tabs = [
    { id: 'create', label: 'Create', component: <CreateCampaignTab onSwitchTab={setActiveTab} /> },
    { id: 'drafts', label: 'Drafts', component: <DraftsTab onSwitchTab={setActiveTab} /> },
    { id: 'history', label: 'History', component: <HistoryTab /> },
  ];

  return (
    <div className="p-4 lg:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl text-white mb-2">Outbound Campaigns</h1>
              <p className="text-gray-400">
            Create and manage outbound calling campaigns
              </p>
            </div>

        {/* Tabs */}
        <div className="mb-6">
          <div className="border-b border-gray-700">
            <nav className="-mb-px flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    py-4 px-1 border-b-2 font-medium text-sm transition-colors
                    ${activeTab === tab.id
                      ? 'border-[#3AD0E6] text-[#3AD0E6]'
                      : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
                    }
                  `}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {tabs.find(tab => tab.id === activeTab)?.component}
        </div>
      </div>
    </div>
  );
};

export default OutboundPage;
